import { render, staticRenderFns } from "./CompTrafficMetric.vue?vue&type=template&id=12acc66f&scoped=true"
import script from "./CompTrafficMetric.vue?vue&type=script&lang=js"
export * from "./CompTrafficMetric.vue?vue&type=script&lang=js"
import style0 from "./CompTrafficMetric.vue?vue&type=style&index=0&id=12acc66f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12acc66f",
  null
  
)

export default component.exports